import { MakeCall } from './createMakeCall';
import { User } from './types/User';

export interface Payload {
  email: string;
  password: string;
}

const login = (makeCall: MakeCall) => (data: Payload) =>
  makeCall<User>('POST', `/api/v2/action/login`, { data });

export { login };
